module.exports = __webpack_public_path__ + "static/img/qrcode-hey-whale.e2715f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-hey-whale.png
// module id = wgVu
// module chunks = 0